import { CommonURLParam } from '~/constants';
import { FormParameterType } from '~/models/form-parameters';
import { Converters } from '~/utils/converters';

export interface FieldNameParamType {
	fieldNameEndsWith: string;
	paramType: FormParameterType;
	alias?: FormParameterType;
}

export class AcurityFieldUtils {
	public static readonly defaultFieldTypes: readonly FieldNameParamType[] = [
		{ fieldNameEndsWith: 'z_Fund', paramType: CommonURLParam.FUND },
		{ fieldNameEndsWith: 'z_Corr_Fund', paramType: CommonURLParam.FUND },
		{ fieldNameEndsWith: 'z_Member', paramType: CommonURLParam.MEMBER },
		{ fieldNameEndsWith: 'z_member', paramType: CommonURLParam.MEMBER },
		{
			fieldNameEndsWith: 'z_Corr_Member',
			paramType: CommonURLParam.MEMBER,
		},
		{
			fieldNameEndsWith: 'z_Category',
			paramType: CommonURLParam.CATEGORY,
		},
		{
			fieldNameEndsWith: 'z_Payroll',
			paramType: CommonURLParam.EMPLOYER,
		},
		{ fieldNameEndsWith: 'z_Name', paramType: CommonURLParam.ADVISER }, // adviser-details, dealer-details
		{
			fieldNameEndsWith: 'z_Payroll',
			paramType: CommonURLParam.EMPLOYER,
		},
		{ fieldNameEndsWith: 'z_Client', paramType: CommonURLParam.CLIENT },
		{
			fieldNameEndsWith: 'z_Corr_Client',
			paramType: CommonURLParam.CLIENT,
		},
		{
			fieldNameEndsWith: 'z_Manager',
			paramType: CommonURLParam.INVESTMENT_MANAGER,
		},
		{
			fieldNameEndsWith: 'z_InvMgr',
			paramType: CommonURLParam.INVESTMENT_MANAGER,
		},
		{
			fieldNameEndsWith: 'z_Adviser',
			paramType: CommonURLParam.ADVISER,
		},
		{
			fieldNameEndsWith: 'BHz_Number',
			paramType: CommonURLParam.ADVISER, // adviser/dealer history
		},
		{
			fieldNameEndsWith: 'z_Adviser_Code',
			paramType: CommonURLParam.ADVISER,
		},
		{
			fieldNameEndsWith: 'l_Trans_Ref',
			paramType: CommonURLParam.TRANS_REF,
		},
		{
			fieldNameEndsWith: 'l_Batch_Ref',
			paramType: CommonURLParam.BATCH_REF,
		},
		{
			fieldNameEndsWith: 'z_Division',
			paramType: CommonURLParam.DIVISION,
		},
		{
			fieldNameEndsWith: 'c_Division',
			paramType: CommonURLParam.DIVISION,
		},
		{
			fieldNameEndsWith: 'z_Batch_Code',
			paramType: CommonURLParam.BATCHES,
		},
		{
			fieldNameEndsWith: 'l_Rct_Ref_No',
			paramType: CommonURLParam.RECEIPT_REF,
		},
		{
			fieldNameEndsWith: 'l_Shr_Cert_No_Sys',
			paramType: CommonURLParam.SHARE_CERTIFICATE_NUMBER_SYSTEM,
		},
		{
			fieldNameEndsWith: 'RPi_Identity',
			paramType: CommonURLParam.RETENTION_PROCESSING_ID,
		},
	];

	/**
	 * Default strategy to give a field description string from concatenation of an array of description.
	 */
	public static descriptionFromArray(descriptionArray: string[]): string {
		return descriptionArray.reduce(
			(acc, val) => acc + val.trim() + ' ',
			'',
		);
	}
}

export const combineModifiedFields = (
	userId: string,
	timeStamp: string,
): string => {
	const modifiedTimeStamp = Converters.dateFormat(timeStamp, 'L HH:mm');
	return userId + ' ' + modifiedTimeStamp;
};
